import { API_URL} from './http';

const getLevels=()=>`${API_URL}/campus-ambassador/current/levels`
const getTasks=(id)=>`${API_URL}/campus-ambassador/current/levels/${id}/tasks`
const startTask=(id)=>`${API_URL}/campus-ambassador/current/tasks/${id}/start`
const getTaskById=(id)=>`${API_URL}/campus-ambassador/current/tasks/${id}`
const submitTask=(id,taskId)=>`${API_URL}/campus-ambassador/current/tasks/${taskId}/submit`
const getAllSubmissions=(caId,taskId)=>`${API_URL}/campus-ambassador/current/${caId}/tasks/${taskId}/submission/details`
const getTaskreport=(taskId)=>`${API_URL }/campus-ambassador/current/tasks/${taskId}/report`
const getLevelById=(levelId)=>`${API_URL }/campus-ambassador/current/levels/${levelId}/remaining-days`
const getRewardDetails=()=>`${API_URL }/campus-ambassador/current/reward/details`
const getRewardById=(taskId)=>`${API_URL }/campus-ambassador/current/tasks/${taskId}/reward`
export default {
    getLevels,
    getTasks,
    startTask,
    getTaskById,
    submitTask,
    getAllSubmissions,
    getTaskreport,
    getLevelById,
    getRewardDetails,
    getRewardById
}